import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export interface SubmitSuccessViewProps {
  onReset: () => void;
}

export function SubmitSuccessView({ onReset }: SubmitSuccessViewProps) {
  const { t } = useTranslation();

  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardContent className="pt-6">
        <div className="text-center space-y-4">
          <div className="text-5xl">✓</div>
          <h2 className="text-2xl font-semibold">{t('feedback.submitSuccess')}</h2>
          <Button onClick={onReset} variant="outline">
            {t('form.submitAnother')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
